import PropTypes from 'prop-types';
import Image from '../../utils/Image';
import HostWrapText from '../../helper/HostWrapText';

import './host-teaser-booking.css';
import logoAxa from './logo-axa.png';
import logoVisa from './logo-visa.png';
import logoMastercard from './logo-mastercard.png';
import logoMaestro from './logo-maestro.png';
import CountryName from '../host/CountryName';
import RatingStars from '../host/RatingStars';
import AccommodationLink from '../host/AccommodationLink';

function HostTeaserBooking(props) {
  return (
    <div className="host-teaser-booking">
      <div className="host-teaser-booking-header">
        <AccommodationLink
          accommodation={props.accommodation}
          className="host-teaser-booking-header-image"
        >
          <Image className="host-teaser-booking-image" src={props.image} />
        </AccommodationLink>
        <div className="host-teaser-booking-like" />
        <div className="host-teaser-booking-header-location">{props.display_title}</div>
      </div>
      <div className="host-teaser-booking-rating">
        <RatingStars rating={props.rating} />
      </div>
      <AccommodationLink accommodation={props.accommodation}>
        <h3 className="host-teaser-booking-title">{props.selling_line}</h3>
      </AccommodationLink>
      <div className="host-teaser-booking-location">
        <span>
          <CountryName countryCode={props.country} />
        </span>
        <HostWrapText item={props.region} />
        <HostWrapText item={props.locality} />
      </div>
      <div className="host-teaser-booking-id">{`ID: ${props.accommodation.id}`}</div>
      <div className="host-teaser-booking-payment">
        <Image
          className="host-teaser-booking-payment-image"
          src={logoAxa}
          alt="Logo Axa"
          width="25"
          height="30"
        />
        <Image
          className="host-teaser-booking-payment-image"
          src={logoVisa}
          alt="Logo Visa"
          width="40"
          height="25"
        />
        <Image
          className="host-teaser-booking-payment-image"
          src={logoMastercard}
          alt="Logo MasterCard"
          width="30"
          height="23"
        />
        <Image
          className="host-teaser-booking-payment-image"
          src={logoMaestro}
          alt="Logo Maestro"
          width="30"
          height="23"
        />
      </div>
    </div>
  );
}

HostTeaserBooking.propTypes = {
  ...HostWrapText.propTypes,
  rating: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  selling_line: PropTypes.string.isRequired,
  display_title: PropTypes.string.isRequired,
  accommodation: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default HostTeaserBooking;
